import React, { useEffect } from "react";
import "../popup.css";
import SubmitButton from "../../Buttons/SubmitButton";
import CancelButton from "../../Buttons/CancelButton";
import BackButton from "../../Buttons/BackButton";
import { redirectToRealMe } from "../../../Services/apiService";
import { gtmPush } from "../../../analytics/useGtmPageview.tsx";

const BrowserBack = ({ onClose }) => {

  useEffect(() => {
      gtmPush("popup_open", {
          popup_id: "browser_back",
          popup_name: "Browser Back Button",
          trigger: "auto",
          page_path: window.location.pathname + window.location.search,
        });
    }, []);

  const handleOverlayClick = (e) => {
    // Only trigger cancel if user clicks directly on the overlay
    if (e.target === e.currentTarget) {
      redirectToRealMe();
    }
  };

  const handleCancelClick = () => {
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <h1 className="modal-title">
          You've clicked the browser back button
        </h1>

        <p className="modal-text">
          Clicking Continue will take you to the RealMe Dashboard.
        </p>

        

        <div className="modal-actions">
          <SubmitButton text={"Continue"} onClick={handleOverlayClick} />
          <CancelButton text={"Close"} onClick={handleCancelClick} />
        </div>
      </div>
    </div>
  );
};

export default BrowserBack;
